module.exports = __webpack_public_path__ + "img/paypal_small.588d8c18.svg";